var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 320,
    height: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M133.976 48.073a.334.334 0 0 1-.333-.31 11.797 11.797 0 0 0-11.734-10.932c-.355 0-.73.018-1.11.054a.334.334 0 0 1-.322-.166 14.018 14.018 0 0 0-25.634 3.048.332.332 0 0 1-.328.241l-.089-.003a3.998 3.998 0 0 0-.138-.003 9.886 9.886 0 0 0-9.634 7.806.334.334 0 0 1-.327.265H61.964a.334.334 0 0 1 0-.668H84.06a10.56 10.56 0 0 1 10.216-8.07 14.685 14.685 0 0 1 26.673-3.133 12.4 12.4 0 0 1 .96-.038 12.467 12.467 0 0 1 12.4 11.552.334.334 0 0 1-.31.356h-.023zm-3.972 4.28H75.261a.334.334 0 1 1 0-.668h54.743a.334.334 0 1 1 0 .668zm-41.391 4.84H70.254a.334.334 0 1 1 0-.668h18.359a.334.334 0 0 1 0 .668z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.778 122.141c0 13.57-14.228 20.064-14.228 20.064s-14.373-6.493-14.665-20.064c-.171-7.976 6.468-14.446 14.447-14.446a14.446 14.446 0 0 1 14.446 14.446z",
    fill: "#e5e5e5",
    style: {
      strokeWidth: 0.234949
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m86.735 143.008-1.167-4.67h11.965l-1.167 4.67z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "M87.063 150.993h8.974v4.677h-8.974z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11 155.743h-9.12v-4.823h9.12zm-8.974-.146h8.829v-4.53h-8.829z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m89.71 143.558-.421-.663h4.523l-.422.663z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    },
    d: "M86.808 143.008h.146v7.15h-.146zm9.339 0h.146v7.15h-.146zm-3.134-4.748-.089-.116c4.216-3.251 9.24-8.82 9.24-16.89a14.353 14.353 0 0 0-8.778-13.245l.057-.134a14.5 14.5 0 0 1 8.868 13.378c0 8.13-5.056 13.735-9.298 17.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.344 138.26-.09-.116c4.216-3.251 9.241-8.82 9.241-16.89a14.37 14.37 0 0 0-8.678-13.202l.057-.134a14.516 14.516 0 0 1 8.767 13.335c0 8.13-5.056 13.735-9.297 17.006z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.32 138.26c-4.242-3.272-9.298-8.877-9.298-17.007a14.516 14.516 0 0 1 8.767-13.335l.058.134a14.37 14.37 0 0 0-8.68 13.201c0 8.07 5.026 13.64 9.242 16.89z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.65 138.26c-4.241-3.272-9.297-8.877-9.297-17.007a14.489 14.489 0 0 1 8.926-13.403l.057.135a14.343 14.343 0 0 0-8.838 13.268c0 8.07 5.026 13.64 9.241 16.89zm1.609-30.565h.146v30.643h-.146z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "m87.063 152.66 2.676-2.675"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45)",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    },
    d: "M-46.384 169.437h3.784v.146h-3.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "m87.063 154.122 3.978-4.183"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.444)",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    },
    d: "M-51.701 169.222h5.772v.146h-5.772z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "M85.932 149.939h10.944v1.313H85.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.95 151.325H85.86v-1.459h11.09zm-10.945-.146h10.799v-1.167H86.005Z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.311 87.75c0 8.956-9.39 13.242-9.39 13.242s-9.487-4.286-9.68-13.243c-.113-5.265 4.27-9.535 9.535-9.535a9.535 9.535 0 0 1 9.535 9.535z",
    fill: "#e5e5e5",
    style: {
      strokeWidth: 0.234949
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m120.742 101.522-.77-3.082h7.898l-.77 3.082z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "M120.959 106.793h5.923v3.087h-5.923z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93 109.928h-6.019v-3.183h6.02zm-5.923-.097h5.827v-2.99h-5.827z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m122.707 101.885-.28-.438h2.987l-.279.438z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    },
    d: "M120.791 101.522h.096v4.719h-.096zm6.164 0h.096v4.719h-.096zm-2.069-3.134-.059-.077c2.783-2.145 6.1-5.821 6.1-11.148a9.474 9.474 0 0 0-5.795-8.741l.038-.09a9.57 9.57 0 0 1 5.853 8.831c0 5.366-3.337 9.066-6.137 11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.804 98.388-.059-.077c2.783-2.145 6.1-5.821 6.1-11.148a9.485 9.485 0 0 0-5.729-8.713l.039-.089a9.581 9.581 0 0 1 5.786 8.802c0 5.366-3.337 9.066-6.137 11.225z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.749 98.388c-2.8-2.16-6.137-5.859-6.137-11.225a9.581 9.581 0 0 1 5.786-8.802l.038.089a9.485 9.485 0 0 0-5.728 8.713c0 5.327 3.317 9.003 6.1 11.148z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.666 98.388c-2.799-2.16-6.136-5.859-6.136-11.225a9.563 9.563 0 0 1 5.892-8.847l.037.09a9.467 9.467 0 0 0-5.833 8.757c0 5.327 3.317 9.003 6.1 11.148zm1.062-20.174h.096V98.44h-.096z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "m120.959 107.893 1.766-1.766"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45)",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    },
    d: "M9.239 161.775h2.498v.096H9.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "m120.959 108.858 2.626-2.761"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.444)",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    },
    d: "M4.458 162.621h3.81v.096h-3.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "M120.213 106.097h7.224v.867h-7.224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.484 107.012h-7.32v-.963h7.32zm-7.223-.096h7.127v-.77h-7.127zm92.879-6.921a.24.24 0 0 0 .239-.222 8.456 8.456 0 0 1 8.41-7.836c.255 0 .523.013.797.039a.24.24 0 0 0 .23-.12 10.048 10.048 0 0 1 18.374 2.186.238.238 0 0 0 .235.172l.064-.001c.033-.002.066-.003.1-.003a7.086 7.086 0 0 1 6.905 5.595.24.24 0 0 0 .234.19h16.03a.24.24 0 1 0 0-.478h-15.839a7.57 7.57 0 0 0-7.322-5.785 10.526 10.526 0 0 0-19.12-2.246 8.885 8.885 0 0 0-.688-.027 8.936 8.936 0 0 0-8.888 8.28.24.24 0 0 0 .222.256h.017zm2.847 3.068h39.24a.24.24 0 1 0 0-.479h-39.24a.24.24 0 0 0 0 .479zm29.669 3.469h13.16a.24.24 0 0 0 0-.478h-13.16a.24.24 0 1 0 0 .478z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "m183.72 164.263-.375-3.037h1.162v3.037z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.708 165.027h-2.54v-.032a.99.99 0 0 1 .989-.989h1.551z",
    fill: "#2f2e41",
    style: {
      strokeWidth: 0.234949
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "m193.988 163.177-1.886-2.411.997-.599 1.564 2.604z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m193.052 164.63-.017-.028a.99.99 0 0 1 .339-1.356l1.33-.799.525.875zm-8.34-.993h-.014a10.576 10.576 0 0 1-1.146-.067c-.145-.014-.303-.03-.493-.045h-.006c-.129-.04-.133-1.253-.078-5.407.028-2.128.06-4.54.022-6.076v-.015l.011-.01a5.774 5.774 0 0 1 5.08-1.29l.014.004.007.012c.774 1.31 1.943 3.196 3.073 5.02 2.595 4.188 3.337 5.42 3.256 5.513l-.01.007c-.178.089-.31.157-.424.215a13.957 13.957 0 0 1-1.377.621l-.021.01-.015-.017c-2.633-2.885-4.824-6.107-6.179-9.086-.158 1.017-.35 2.345-.553 3.748-.584 4.034-.979 6.691-1.138 6.853z",
    fill: "#2f2e41",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.421 152.352a13.79 13.79 0 0 1 4.611.772 10.496 10.496 0 0 0-2.353-6.843l-.011-.013.006-.018c.413-1.194.84-2.43 1.223-3.658l-.005-.021c-.268-.952-.843-1.915-1.758-2.942a.563.563 0 0 0-.769-.039 7.16 7.16 0 0 0-2.307 5.83v.005l-.001.006c-.717 2.427-.977 3.674-1.206 4.773a28.949 28.949 0 0 1-.603 2.49 14.948 14.948 0 0 1 3.174-.342z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m187.732 144.68-2.33 5.074-1.332-1.348z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 186.736,
    cy: 137.477,
    r: 1.658,
    fill: "#9f616a",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.726 136.54h2.632v-1.147c-.577-.23-1.143-.425-1.485 0a1.148 1.148 0 0 0-1.147 1.148z",
    fill: "#2f2e41",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.504 135.19c1.574 0 2.015 1.973 2.015 3.086 0 .62-.281.843-.722.918l-.156-.83-.365.866c-.124 0-.254-.002-.389-.004l-.124-.255-.275.25c-1.105.002-1.998.163-1.998-.945 0-1.112.386-3.085 2.014-3.085z",
    fill: "#2f2e41",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.045 58.59c0 43.701-45.816 64.612-45.816 64.612s-46.285-20.91-47.224-64.611c-.553-25.687 20.827-46.52 46.52-46.52 25.692 0 46.52 20.827 46.52 46.52z",
    fill: "#48b2d2",
    style: {
      strokeWidth: 0.234949
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb7b7",
    d: "m189.246 163.92-.459-3.725h1.425v3.725z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.557 163.644h1.862v1.173h-3.035a1.173 1.173 0 0 1 1.173-1.173z",
    fill: "#2f2e41",
    style: {
      strokeWidth: 0.234949
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb7b7",
    d: "m192.87 163.92-.46-3.725h1.426v3.725z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.18 163.644h1.863v1.173h-3.036a1.173 1.173 0 0 1 1.173-1.173z",
    fill: "#2f2e41",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.718 152.826a.846.846 0 0 1-.163-1.287l-.636-9.024 1.832.178.05 8.837a.85.85 0 0 1-1.083 1.296z",
    fill: "#ffb7b7",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.167 162.044-1.064-.051a.354.354 0 0 1-.337-.352l-.074-10.756a.355.355 0 0 1 .405-.354l4.253.618a.352.352 0 0 1 .304.348l.547 9.967a.355.355 0 0 1-.355.357H192.7a.353.353 0 0 1-.35-.3s-.866-7.475-.985-7.471c-.12.002-.83 7.682-.83 7.682a.356.356 0 0 1-.352.312h-.016z",
    fill: "#2f2e41",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.334 145.547a.353.353 0 0 1-.146-.268l-.135-2.432a.977.977 0 0 1 1.918-.31l.59 2.175a.355.355 0 0 1-.25.435l-1.677.455a.353.353 0 0 1-.3-.055z",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.767,
    cy: 137.832,
    r: 1.935,
    fill: "#ffb7b7",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.136 139.363a.625.625 0 0 1-1.078-.347.635.635 0 0 1 0-.123c.025-.232.16-.444.127-.69a.362.362 0 0 0-.066-.169c-.287-.385-.962.173-1.234-.176-.166-.214.03-.55-.098-.79-.169-.315-.668-.16-.981-.332-.349-.192-.328-.726-.099-1.052a1.654 1.654 0 0 1 1.255-.638 3.365 3.365 0 0 1 1.417.276 2.832 2.832 0 0 1 1.34.929 2.267 2.267 0 0 1 .228 1.93c-.117.39-.516.868-.81 1.182z",
    fill: "#2f2e41",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.698 141.06q-.05-.037-.102-.072a2.549 2.549 0 0 0-.599-.293v-.509h-1.496v.472a2.625 2.625 0 0 0-1.904 2.18l-1.019 7.567a.353.353 0 0 0 .074.268.348.348 0 0 0 .24.131 5.35 5.35 0 0 1 2.023.693 3.003 3.003 0 0 0 1.473.376 3.552 3.552 0 0 0 1.2-.213.352.352 0 0 0 .23-.316c.036-.814.25-5.005.876-7.561a2.613 2.613 0 0 0-.996-2.724z",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m173.723 125.786-3.76-15.037h38.532l-3.759 15.037z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "M174.78 151.502h28.899v15.06H174.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.914 166.796h-29.369v-15.53h29.369zm-28.899-.47h28.429v-14.59h-28.429Z",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m183.306 127.56-1.36-2.137h14.567l-1.36 2.136z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    },
    d: "M173.958 125.786h.47v23.025h-.47zm30.073 0h.47v23.025h-.47zm-10.091-15.291-.287-.372C207.228 99.654 223.41 81.72 223.41 55.73a46.222 46.222 0 0 0-28.27-42.648l.184-.433a46.69 46.69 0 0 1 28.556 43.08c0 26.18-16.282 44.232-29.94 54.765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.903 110.495-.287-.372c13.575-10.469 29.757-28.403 29.757-54.392a46.276 46.276 0 0 0-27.947-42.51l.186-.432a46.746 46.746 0 0 1 28.23 42.942c0 26.18-16.28 44.231-29.94 54.764z",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.146 110.495c-13.658-10.533-29.94-28.584-29.94-54.764a46.745 46.745 0 0 1 28.231-42.942l.187.432a46.276 46.276 0 0 0-27.948 42.51c0 25.989 16.182 43.923 29.757 54.392z",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11 110.495c-13.66-10.533-29.94-28.585-29.94-54.765a46.658 46.658 0 0 1 28.746-43.16l.181.433A46.19 46.19 0 0 0 153.64 55.73c0 25.99 16.182 43.923 29.757 54.392zm5.18-98.424h.47v98.679h-.47z",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "m174.78 156.87 8.617-8.617"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45)",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    },
    d: "M12.664 234.277H24.85v.47H12.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "m174.78 161.576 12.81-13.47"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.444)",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    },
    d: "M3.338 237.766h18.589v.47H3.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      strokeWidth: 0.234949
    },
    d: "M171.138 148.106h35.242v4.229h-35.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.616 152.57h-35.713v-4.699h35.713zm-35.243-.47h34.773v-3.759h-34.773z",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.537 150.073a.646.646 0 0 0 .581-.801l1.92-1.259-1.094-.473-1.656 1.268a.65.65 0 0 0 .249 1.265z",
    fill: "#9f616a",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.384 149.167-.024-.017a51.752 51.752 0 0 0-1.455-1.02l-.03-.021.024-.027a234.1 234.1 0 0 0 3.11-3.743l-.003-.004.01-.004.004-.005.002.002.006-.003-.027.002-.313-2.451a1.571 1.571 0 0 1 .034-1.683 1.333 1.333 0 0 1 1.735-.397 1.138 1.138 0 0 1 .5.85 1.027 1.027 0 0 1-.272.841 35.354 35.354 0 0 1 .142 3.578v.011l-.007.01c-1.08 1.373-2.268 2.739-3.416 4.06z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.757 141.633a.829.829 0 0 1 .018.13l3.384 1.952.823-.474.876 1.148-1.759 1.254-3.86-3.045a.827.827 0 1 1 .518-.965z",
    fill: "#ffb7b7",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.28 143.549a.353.353 0 0 1 .102-.288l1.722-1.723a.977.977 0 0 1 1.51 1.222l-1.227 1.89a.355.355 0 0 1-.49.105l-1.457-.946a.353.353 0 0 1-.16-.26z",
    fill: "#3f3d56",
    style: {
      strokeWidth: 0.234949
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.849 126.78a.24.24 0 0 1-.239-.223 8.456 8.456 0 0 0-8.41-7.835c-.255 0-.523.012-.797.038a.24.24 0 0 1-.23-.12 10.048 10.048 0 0 0-18.374 2.186.238.238 0 0 1-.235.173l-.064-.002c-.033-.001-.066-.003-.1-.003a7.086 7.086 0 0 0-6.905 5.595.24.24 0 0 1-.234.19h-16.03a.24.24 0 1 1 0-.479h15.839a7.57 7.57 0 0 1 7.322-5.785 10.526 10.526 0 0 1 19.12-2.245 8.91 8.91 0 0 1 .688-.028 8.936 8.936 0 0 1 8.888 8.28.24.24 0 0 1-.222.256h-.017zm-2.847 3.067h-39.24a.24.24 0 1 1 0-.478h39.24a.24.24 0 1 1 0 .478zm-29.669 3.47h-13.16a.24.24 0 1 1 0-.479h13.16a.24.24 0 1 1 0 .479z",
    fill: "#cbcbcb",
    style: {
      strokeWidth: 0.234949
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.079f134fcaf19fcad1d9b056b3e4cb03.svg";
export { ForwardRef as ReactComponent };